import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
} from "antd";

const CommonDrawer = ({
  open,
  setOpen,
  title,
  width,
  extra,
  children,
  isSubmitBtn = { show: false, label: "Submit", loading: false },
  onSubmit,
  isCancelBtn = { show: true, label: "Close" },
}) => {
  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Drawer
        title={<h1 className="text-2xl font-medium">{title}</h1>}
        width={width}
        onClose={onClose}
        open={open}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={
          <Space>
            {isCancelBtn.show && (
              <Button
                onClick={onClose}
                className="h-10 w-[140px] hover:!border-primary hover:!text-primary"
              >
                {isCancelBtn.label}
              </Button>
            )}
            {isSubmitBtn.show && (
              <Button
                onClick={onSubmit}
                type="primary"
                className="h-10 !bg-primary !text-white w-[140px]"
              >
                {isSubmitBtn.label}
              </Button>
            )}
          </Space>
        }
      >
        {children}
      </Drawer>
    </>
  );
};

export default CommonDrawer;
